<div class="col p-0">
    <!-- <div class="alert alert-info mt-4">
    {{'CONFIGURE.DATA_TEMP_READ_ONLY' | translate }}
  </div> -->

  <div class="search-box">
    <div class="col-auto p-0" *ngIf="addNewRow">
      <button class="btn-bd-empty" (click)="addRow()">{{ 'CONFIGURE.ADD_NEW' | translate }}</button>
    </div>
    <div class="col-auto p-0 mt-4">
      <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
    </div>
  </div>

    <div class="col-12 static-card">
        <bd-light-table #grid [gridData]="gridData || [] | search:searchText:['categoryName','professionalCategory','subCategoryName']" 
        [pageInfo]="pageInfo" 
        [fields]="fields" 
        [addNewRow]="addNewRow"
        [inlineAddRow]=true
        [actions]="actionItems"
        (handlerData)="handlerData($event)"></bd-light-table>
    </div>

</div>

<ng-template #delmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
      <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
      <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img
          src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
      <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }} </p>
    </div>
    <div class="modal-footer">
      <div class="align-items-end d-flex">
        <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
        <button (click)="delete();modalRef.hide();" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
      </div>
    </div>
  </ng-template>

  <ng-template #institutionsmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
      <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
      <a class="cursor" data-dismiss="modal" (click)="cleanSearch(); modalRef.hide(); "><img
          src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body institutions">
      <div class="mr-3 bd-input search mt-4 d-flex justify-content-end">
        <input type="text" id="input" required="" inputSanitizer maxlength="100" class="" #modelSopTitle="ngModel"
          [ngClass]="searchTextInstitution ? 'filled': '' " [(ngModel)]="searchTextInstitution">
        <mat-icon class="search">search</mat-icon>
        <label for="input" class="label" [ngClass]="searchTextInstitution ? 'filled': '' ">{{ 'INSTITUTION_MANAGEMENT.SEARCH' |
          translate}}</label>
        <button class="clean" (click)="cleanSearch()"><mat-icon>close</mat-icon></button>
        <div class="underline"></div>
      </div>

      <div class="institutions-container-list">
        <div class="p-0 mb-2 w-100">
          <input type="checkbox" class="custom-control-input " id="selectAll" [(ngModel)]="selectAllChecked"
            (change)="checkAll($event)">
          <label for="selectAll">{{ 'INSTITUTION_MANAGEMENT.SELECT_ALL' | translate }}</label>
        </div>
        <div class="mb-2" *ngFor='let data of institutionList | search:searchTextInstitution'>
          <ng-template [ngIf]="!data.institution.institution.isGroup">
            <input type="checkbox" class="custom-control-input"
              (change)="checkOne($event, data.institution.institution.institutionID)"
              [checked]="isChecked(data.institution.institution.institutionID)"
              id="customCheck-{{data.institution.institution.institutionID}}">
            <label
              for="customCheck-{{data.institution.institution.institutionID}}">{{data.institution.institution.institutionName
              | labelSanitizer}}</label>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="align-items-end d-flex">
        <button (click)="cleanSearch(); modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ translationKeys.Button.No | translate }}</button>
        <button (click)="saveVisibility();modalRef.hide();" class="btn-bd-empty">{{ translationKeys.Button.Yes | translate }}</button>
      </div>
    </div>
  </ng-template>